import type { ResourceArticle } from '~/types/ResourceArticle'

export const understandingSpiritualCrisisArticle: ResourceArticle = {
  uid: 'understanding-spiritual-crisis',
  thumbnailImageUrl: 'https://cdn.hubofhope.co.uk/public/img/thumbs/RESOURCES_SPIRITUAL_800x800.jpg',
  thumbnailImageAlt: 'Spiritual',
  title: 'Understanding spiritual crisis',
  // TODO - is this the correct snc to link to?
  supportNeedCategoryUid: 'mO7BanEhavw24zQKyYZo',
  supportNeedCategoryLabel: 'Urgent and crisis support',
  isFeatured: true,
  excerpt:
    'Many people believe that experiences of mental and emotional distress, including those sometimes called psychosis, can be deeply transformative, offering the possibility of breakthrough rather than – or as well as – breakdown.',
  content: `
  <div class="prose mt-4">
    <p>
      Many people believe that experiences of mental and emotional distress, including those sometimes called psychosis 
      (<a href="/resource/psychosis-hearing-voices" class="text-blue-500 underline hover:text-blue-700">see Psychosis & hearing voices</a>), 
      can be deeply transformative, offering the possibility of breakthrough rather than – or as well as – breakdown.
    </p>
  
    <h2 class="font-semibold text-lg font-brown text-primary mt-6">Spiritual crisis can be the beginning of a transformation</h2>
    <p>
      Periods of turmoil – often linked to past traumatic experiences 
      (<a href="/resource/trauma-post-traumatic-stress" class="text-blue-500 underline hover:text-blue-700">see Trauma & post-traumatic stress</a>) – 
      can be seen as a natural, though painful, part of our ongoing journey towards a fuller, deeper life. A profound spiritual or 
      existential crisis that can lead to important insights and positive change. The Spiritual Crisis Network suggests that a mental 
      health crisis can be a wake-up call, our psyche's attempt to heal itself and an opportunity for healing and growth – 
      <a href="https://spiritualcrisisnetwork.uk" class="text-blue-500 underline hover:text-blue-700">spiritualcrisisnetwork.uk</a>.
    </p>
  
    <blockquote class="italic border-l-4 border-gray-300 pl-4 mt-4">
      “Spiritual crisis, often called spiritual emergency, awakening or psycho-spiritual crisis, is a turbulent period of 
      psychological opening and transformation.” – 
      <a href="https://spiritualcrisisnetwork.uk" class="text-blue-500 underline hover:text-blue-700">Spiritual Crisis Network</a>
    </blockquote>
  
    <figure class="my-8">
      <img src="https://cdn.hubofhope.co.uk/public/img/thumbs/pexels-shvetsa-4557386_800x800.jpg" 
           alt="Spiritual crisis article image" 
           class="max-w-md w-full h-auto rounded shadow-md mx-auto">
    </figure>
  
    <h2 class="font-semibold text-lg font-brown text-primary mt-8">How to seek help</h2>
    <p class="mb-8">
      In terms of support, different things help different people. There are some useful self-help resources (e.g., 
      <a href="https://www.spiritualemergencenetwork.org/resources/crisis-guide-emerge-crisis/" class="text-blue-500 underline hover:text-blue-700">ISEN Crisis Guide</a>). Often practical things such as 
      self-care are central, including exercise, eating, and sleeping well. Doing things that connect us with others, including people 
      with similar experiences, either informally or in organised peer support groups, can be a big help. Therapy or counselling, 
      with someone who has an understanding of a spiritual crisis, can help us to make sense of our experiences and talk through 
      what might help.
    </p>
  </div>`
}
